import React from 'react';
import { compose, graphql } from 'react-apollo';
import {
  Button,
  Icon,
  Image,
  Menu,
  Responsive,
  Sidebar,
  Ref,
  Dropdown,
} from 'semantic-ui-react';
import _ from 'lodash';
import gql from 'graphql-tag';
import Link from 'components/Link';
import CalculatorLink from 'components/CalculatorLink';
import { withRouter } from 'react-router';
import FullWhiteLogoImg from 'images/logo/full-white.svg';
import BirdWhiteLogoImg from 'images/logo/full-white-bird.svg';
import Routes from 'config/routes';
import LocaleToggle from 'components/LocaleToggle';
import { AUTH_TOKEN } from 'config/constants';
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from './messages';
import TrackIcon from 'images/track.svg';
import { asCurrency, localizeCurrency } from 'lib/newHelpers';

class Header extends React.Component {
  // eslint-disable-line react/prefer-stateless-function
  state = {
    calculations: {
      direction: 'none',
      height: 0,
      width: 0,
      topPassed: false,
      bottomPassed: false,
      pixelsPassed: 0,
      percentagePassed: 0,
      topVisible: false,
      bottomVisible: false,
      fits: false,
      passing: false,
      onScreen: false,
      offScreen: false,
    },
    activePath: this.props.location.pathname || '/',
    menuElement: this.menuElement || {
      clientHeight: 59,
    },
    loginOpen: false,
    registerOpen: false,
    registerMessage: '',
  };

  setRegisterMessage = (msg) => {
    this.setState({
      registerMessage: msg,
    });
  };

  getMainMenuItems = () => this.mainMenuItems();
  getSidebarItems = () => this.sidebarItems();

  shoppingCart = () => ({
    // title: `${this.props.intl.formatMessage({ ...messages.cartItem })}`,
    route: Routes.Cart,
    linkType: Link,
    isPrivate: false,
    active: () =>
      this.state.activePath.split('/')[1] === Routes.Cart.split('/')[1],
    iconName: 'shopping cart',
  });

  lynksOffers = () => ({
    title: `${this.props.intl.formatMessage({ ...messages.offers })}`,
    route: Routes.Promotions,
    linkType: Link,
    isPrivate: false,
    active: () =>
      this.state.activePath.split('/')[1] === Routes.Promotions.split('/')[1],
    iconName: 'certificate',
  });

  mainMenuItems = () => {
    const items = [
      {
        title: `${this.props.intl.formatMessage({ ...messages.cartItem })}`,
        route: Routes.Cart,
        linkType: Link,
        isPrivate: false,
        active: () =>
          this.state.activePath.split('/')[1] === Routes.Cart.split('/')[1],
        iconName: 'shopping cart',
      },
      {
        title: `${this.props.intl.formatMessage({ ...messages.track })}`,
        route: Routes.Tracking,
        linkType: Link,
        isPrivate: true,
        active: () =>
          this.state.activePath.split('/')[1] === Routes.Tracking.split('/')[1],
        iconName: 'shipping',
      },
    ];

    const countryCode = this.props.currentUser.country
      ? this.props.currentUser.country.iso_code
      : this.props.geo.countryCode;

    if (countryCode === 'EG') {
      if (!this.props.currentUser.newCartExperience) {
        items.push({
          title: `${this.props.intl.formatMessage({ ...messages.offers })}`,
          route: Routes.Promotions,
          linkType: Link,
          isPrivate: false,
          active: () =>
            this.state.activePath.split('/')[1] ===
            Routes.Promotions.split('/')[1],
          iconName: 'certificate',
        });
      }
    }

    items.push({
      title: `${this.props.intl.formatMessage({ ...messages.howItWorksItem })}`,
      route: Routes.HowItWorks,
      linkType: Link,
      isPrivate: false,
      active: () =>
        this.state.activePath.split('/')[1] ===
        Routes.HowItWorks.split('/')[1],
      iconName: 'linkify',
    });

    items.push({
      title: `${this.props.intl.formatMessage({
        ...messages.calculatorItem,
      })}`,
      route: '',
      linkType: CalculatorLink,
      active: () => null,
      iconName: 'calculator',
    });

    return items;
  };

  sidebarItems = () => {
    const items = [
      {
        title: `${this.props.intl.formatMessage({ ...messages.cartItem })}`,
        route: Routes.Cart,
        linkType: Link,
        isPrivate: false,
        active: () =>
          this.state.activePath.split('/')[1] === Routes.Cart.split('/')[1],
        iconName: 'shopping cart',
      },
      {
        title: `${this.props.intl.formatMessage({ ...messages.track })}`,
        route: Routes.Tracking,
        linkType: Link,
        isPrivate: true,
        active: () =>
          this.state.activePath.split('/')[1] === Routes.Tracking.split('/')[1],
        iconName: 'shipping',
      },
    ];

    const countryCode = this.props.currentUser.country
      ? this.props.currentUser.country.iso_code
      : this.props.geo.countryCode;

    if (countryCode === 'EG') {
      if (!this.props.currentUser.newCartExperience) {
        items.push({
          title: `${this.props.intl.formatMessage({ ...messages.offers })}`,
          route: Routes.Promotions,
          linkType: Link,
          isPrivate: false,
          active: () =>
            this.state.activePath.split('/')[1] ===
            Routes.Promotions.split('/')[1],
          iconName: 'certificate',
        });
      }
    }

    items.push({
      title: `${this.props.intl.formatMessage({ ...messages.howItWorksItem })}`,
      route: Routes.HowItWorks,
      linkType: Link,
      isPrivate: false,
      active: () =>
        this.state.activePath.split('/')[1] ===
        Routes.HowItWorks.split('/')[1],
      iconName: 'linkify',
    });

    items.push({
      title: `${this.props.intl.formatMessage({ ...messages.help })}`,
      route: Routes.Faq,
      linkType: Link,
      isPrivate: false,
      active: () =>
        this.state.activePath.split('/')[1] ===
        Routes.Faq.split('/')[1],
      iconName: 'question circle outline',
    });

    items.push({
      title: `${this.props.intl.formatMessage({
        ...messages.calculatorItem,
      })}`,
      route: '',
      linkType: CalculatorLink,
      active: () => null,
      iconName: 'calculator',
    });

    return items;
  };

  hideFixedMenu = () => this.setState({ fixed: false });
  showFixedMenu = () => this.setState({ fixed: true });
  handleToggle = () =>
    this.setState({ sidebarOpened: !this.state.sidebarOpened });
  handleLogIn = () => this.setState({ modalOpen: true });
  handleUpdate = (e, { calculations }) => this.setState({ calculations });

  toggleLogin = () => {
    this.setState({ loginOpen: !this.state.loginOpen });
  };

  toggleRegister = () => {
    if (this.state.registerOpen) this.setRegisterMessage('');
    this.setState({ registerOpen: !this.state.registerOpen });
  };

  menuItem = (item, i, style, iconStyle) => (
    <Menu.Item
      key={i}
      as={item.linkType}
      to={item.route}
      active={item.active()}
      isPrivate={!!item.isPrivate}
      currentUser={this.props.currentUser}
      geo={this.props.geo}
      style={style}
    >
      {item.iconName === 'shipping' ? (
        <span>
          <Image
            inline
            src={TrackIcon}
            style={{ height: '15px', width: '20px' }}
            size="tiny"
            centered
          />
          &nbsp;
          <span>{item.title}</span>
        </span>
      ) : (
        <span>
          <Icon name={item.iconName} style={iconStyle} />
          {!!item.title && <span>{item.title}</span>}
        </span>
      )}
    </Menu.Item>
  );

  render() {
    const { sidebarOpened } = this.state;

    return (
      <div>
        <div
          style={{
            height: `${this.state.menuElement.clientHeight}px`,
            minHeight: '59px',
          }}
        />

        <Ref
          innerRef={(e) => {
            this.menuElement = e;
          }}
        >
          <Menu
            fixed="top"
            inverted
            secondary
            size="large"
            borderless
            style={{
              background: 'Linear-gradient(90deg, #ee5c74 0%,#f49942 100%)',
              marginBottom: 0,
            }}
          >
            {/* only mob */}
            <Responsive as={Menu.Menu} maxWidth={1023}>
              <Menu.Item
                icon
                onClick={this.handleToggle}
                style={{ padding: '0.2em' }}
              >
                <Icon name="sidebar" style={{ fontSize: '1.3em' }} />
              </Menu.Item>
              {this.menuItem(
                this.shoppingCart(),
                0,
                { padding: '0.2em' },
                { fontSize: '1.3em' }
              )}
              {this.menuItem(
                this.lynksOffers(),
                1,
                { padding: '0.2em' },
                { fontSize: '1.3em' }
              )}
            </Responsive>

            {/* only computer */}
            <Responsive as={Menu.Menu} minWidth={1024}>
              {this.getMainMenuItems().map((item, i) => this.menuItem(item, i))}
            </Responsive>

            <Menu.Menu position="right">
              <Responsive as={Menu.Item} minWidth={1024}>
                <LocaleToggle />
              </Responsive>

              {this.props.isLoggedIn && (
                <Dropdown
                  pointing
                  item
                  trigger={
                    <div style={{ display: 'flex' }}>
                      <Icon size="big" name="user circle" />
                      <div style={{ color: '#fff' }}>
                        <Responsive minWidth={1024}>
                          {_.truncate(this.props.currentUser.full_name, {
                            length: 14,
                          }).toLowerCase()}
                          {this.props.currentUser.wallet && (
                            <span>
                              <br />
                              <b style={{ fontSize: '0.75em', color: '#b12704' }}>
                                {asCurrency(
                                  this.props.currentUser.wallet.authorized_balance
                                )}
                                &nbsp;
                                {localizeCurrency(
                                  this.props.intl.locale,
                                  this.props.currentUser.wallet.currency.code
                                )}
                              </b>
                            </span>
                          )}
                        </Responsive>
                      </div>
                    </div>
                  }
                >
                  <Dropdown.Menu>
                    <Dropdown.Item
                      as={Link}
                      name="Legacy Orders"
                      to={Routes.AccountLegacyOrders}
                    >
                      <FormattedMessage {...messages.trackLegacyOrdersItem} />
                    </Dropdown.Item>
                    <Dropdown.Item
                      as={Link}
                      name="Profile"
                      to={Routes.AccountProfile}
                    >
                      <FormattedMessage {...messages.profileItem} />
                    </Dropdown.Item>
                    <Dropdown.Item
                      as={Link}
                      name="Wallet"
                      to={Routes.AccountWallet}
                    >
                      <FormattedMessage {...messages.walletItem} />
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => {
                        localStorage.removeItem(AUTH_TOKEN);
                        window.FB.logout();
                        window.location.reload();
                      }}
                    >
                      <FormattedMessage {...messages.logoutItem} />
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              )}

              {!this.props.isLoggedIn && (
                <Responsive as={Menu.Item} maxWidth={1250}>
                  <Button as={Link} to="" isPrivate basic inverted>
                    <FormattedMessage {...messages.loginItem} />
                  </Button>
                </Responsive>
              )}

              {!this.props.isLoggedIn && (
                <Responsive as={Menu.Item} minWidth={1251}>
                  <Button as={Link} to="" isPrivate basic inverted>
                    <FormattedMessage {...messages.loginItem} />
                  </Button>
                </Responsive>
              )}

              {!this.props.isLoggedIn && (
                <Responsive as={Menu.Item} minWidth={1251}>
                  <Button
                    as={Link}
                    to=""
                    isPrivate
                    contentFor="register"
                    inverted
                  >
                    <FormattedMessage {...messages.createItem} />
                  </Button>
                </Responsive>
              )}

              {/* only computer */}
              <Responsive as={Menu.Menu} minWidth={1024}>
                <Menu.Menu>
                  <Menu.Item as={Link} to={Routes.Home}>
                    <img
                      alt="Lynks"
                      style={{ width: '6em' }}
                      src={FullWhiteLogoImg}
                    />
                  </Menu.Item>
                </Menu.Menu>
              </Responsive>

              {/* only mob */}
              <Responsive as={Menu.Menu} maxWidth={1023}>
                <Menu.Menu>
                  <Menu.Item as={Link} to={Routes.Home}>
                    <img
                      alt="Lynks"
                      style={{ width: '2.5em' }}
                      src={BirdWhiteLogoImg}
                    />
                  </Menu.Item>
                </Menu.Menu>
              </Responsive>
            </Menu.Menu>
          </Menu>
        </Ref>

        <Sidebar
          as={Menu}
          width="thin"
          animation="slide along"
          inverted
          vertical
          icon="labeled"
          visible={sidebarOpened}
          style={{
            top: this.state.menuElement.clientHeight
              ? `${this.state.menuElement.clientHeight}px`
              : '59px',
          }}
        >
          {this.getSidebarItems().map((item, i) => this.menuItem(item, i))}
          <Menu.Item>
            <LocaleToggle />
          </Menu.Item>
        </Sidebar>

        <Sidebar.Pushable style={{ backgroundColor: '#fafafa' }}>
          <Sidebar.Pusher
            dimmed={sidebarOpened}
            onClick={() => sidebarOpened && this.handleToggle()}
            // style={{
            //   display: 'flex',
            //   minHeight: 'calc(100vh - 59px)',
            //   flexDirection: 'column',
            // }}
            // style={
            //   sidebarOpened
            //     ? { overflowY: 'clip', height: 'calc(100vh - 59px)' }
            //     : undefined
            // }
          >
            {this.props.children}
          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </div>
    );
  }
}

const IS_LOGGED_IN = gql`
  query IsLoggedIn {
    isLoggedIn
  }
`;

export default compose(
  withRouter,
  injectIntl,
  graphql(IS_LOGGED_IN, {
    options: { fetchPolicy: 'cache-only' },
    props: ({ data: { isLoggedIn } }) => ({
      isLoggedIn,
    }),
  })
)(Header);



// WEBPACK FOOTER //
// ./app/components/Header/index.js